import React, { useEffect, useState } from 'react';
import './cards.css'; // Custom styles
import { Link } from 'react-router-dom';
import { ImageUrl } from '../saas/Config/Image';
import { COLOR } from '../saas/Config/Color';

const AttendanceCard = ({ shiftHours, punchTime }) => {

    const userDetails = JSON.parse(sessionStorage.getItem("userDetails")) || {}
    const login_time = userDetails?.user?.login_time?.replace(' ', 'T');
    const punchInTime = new Date(login_time); // Start time
    const punchProductionTime = new Date(login_time); // Production threshold

    const [currentTime, setCurrentTime] = useState(new Date());
    const [workedTime, setWorkedTime] = useState('00:00:00');
    const [progress, setProgress] = useState(0);
    const [productionHours, setProductionHours] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            setCurrentTime(now);

            const diffMs = now - punchInTime;
            const diff = new Date(diffMs);

            const hours = String(diff.getUTCHours()).padStart(2, '0');
            const minutes = String(diff.getUTCMinutes()).padStart(2, '0');
            const seconds = String(diff.getUTCSeconds()).padStart(2, '0');
            setWorkedTime(`${hours}:${minutes}:${seconds}`);

            const totalWorkedSeconds = diff.getUTCHours() * 3600 + diff.getUTCMinutes() * 60 + diff.getUTCSeconds();
            const totalShiftSeconds = shiftHours * 3600;
            setProgress(Math.min((totalWorkedSeconds / totalShiftSeconds) * 100, 100));

            if (now > punchProductionTime) {
                const prodDiff = new Date(now - punchProductionTime);
                const prodHrs = (prodDiff.getUTCHours() + prodDiff.getUTCMinutes() / 60).toFixed(2);
                setProductionHours(prodHrs);
            } else {
                setProductionHours(0);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [shiftHours]);

    const radius = 70;
    const stroke = 7;
    const normalizedRadius = radius - stroke * 0.5;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset = circumference - (progress / 100) * circumference;

    return (
        <div className="card flex-fill m-0 attendance-bg">
            {
                shiftHours && login_time ?
                    <div className="card-body">
                        <div className="mb-4 text-center">
                            <h6 className="fw-medium text-gray-5 mb-1">Attendance</h6>
                            <h4>
                                {punchInTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })},{" "}
                                {punchInTime.toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric'
                                })}
                            </h4>
                        </div>

                        <div className="d-flex justify-content-center align-items-center pb-2">
                            <svg height={160} width={160} className="circular-progress">
                                <circle
                                    stroke="#fff"
                                    fill="transparent"
                                    strokeWidth={stroke}
                                    r={normalizedRadius}
                                    cx={80}
                                    cy={80}
                                />
                                <circle
                                    stroke="#00c853"
                                    fill="transparent"
                                    strokeWidth={stroke}
                                    strokeLinecap="round"
                                    strokeDasharray={circumference}
                                    strokeDashoffset={strokeDashoffset}
                                    r={normalizedRadius}
                                    cx={80}
                                    cy={80}
                                    className="circular-progress-bar"
                                />
                                <text x="50%" y="45%" textAnchor="middle" className="circular-progress-label">
                                    Total Hours
                                </text>
                                <text x="50%" y="60%" textAnchor="middle" className="circular-progress-time">
                                    {workedTime}
                                </text>
                            </svg>
                        </div>

                        <div className="text-center">
                            <div className="badge badge-dark badge-md mb-3">Production: {productionHours} Hrs</div>
                            <h6 className="fw-medium d-flex align-items-center justify-content-center mb-4">
                                <i className="ti ti-fingerprint  me-1"></i>
                                Punch Production at {punchProductionTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                            </h6>
                            <Link to="/employee/logout" className="btn btn-primary w-100">Punch Out</Link>
                        </div>
                    </div> :
                    <div
                        style={{
                            display: "flex", // Add this line
                            flexDirection: "column", // Add this line to stack items vertically
                            color: "#888888",
                            fontWeight: "600",
                            marginTop: "25px",
                            marginBottom: "25px",
                            justifyContent: "center",
                            alignItems: "center",
                            // height: "100vh", // Optional: Ensure the div takes the full height of the viewport
                        }}
                    >
                        <img
                            src={ImageUrl.NODATA}///Assets/NewImage/Dumy.png
                            style={{
                                width: "50px",
                                height: "50px",
                            }}
                        />
                        <p
                            style={{
                                fontWeight: "600",
                                fontSize: "14px",
                                //fontFamily: "Inter",
                                color: COLOR.GRAY1,
                            }}
                        >
                            Please login  first !
                        </p>
                    </div>
            }
        </div>
    );
};

export default AttendanceCard;
